import { UnknownAction } from "@reduxjs/toolkit";
import { QueryActionCreatorResult, QueryDefinition } from "@reduxjs/toolkit/query";
import { redirect } from "@tanstack/react-router";
import { logout } from "hooks/useLogout";
import { ThunkAction } from "redux-thunk";
import { BackendErrorType } from "services/helpers";
import store from "store";

// https://github.com/TkDodo/blog-comments/discussions/84#discussioncomment-3837326
export async function preloadQueries(...queriesAction: ThunkAction<QueryActionCreatorResult<QueryDefinition<any, any, any, any, "api">>, any, any, UnknownAction>[]) {
    const tasks = queriesAction.map(async action => {
        const promise = store.dispatch(action);
        // wait for data to be there
        const res = await promise;
        // remove the subscription. The data will stay in cache for 60 seconds (default) and the component can subscribe to it in that timeframe.
        promise.unsubscribe();

        // Immediately logout and redirect if the request is unauthorized (token is likely expired)
        if ((res.error as BackendErrorType)?.httpStatusCode == 401) {
            await logout();
            throw redirect({
                to: '/auth/login',
            });
        }
        return res;
    });
    return await Promise.all(tasks);
};
